import { render, staticRenderFns } from "./ImportCustomersModal.vue?vue&type=template&id=50ec711e&scoped=true"
import script from "./ImportCustomersModal.vue?vue&type=script&lang=js"
export * from "./ImportCustomersModal.vue?vue&type=script&lang=js"
import style0 from "./ImportCustomersModal.vue?vue&type=style&index=0&id=50ec711e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ec711e",
  null
  
)

export default component.exports